import { db } from '../firebase/firebase-config';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { handleError, whichEnvURL } from '../helpers/utils';
import { setTime } from '../helpers/hours';

// Create a function to fetch the filtered and sorted documents
export const getIncidents = async (
	startDate,
	endDate,
	searchOption,
	division,
	managerId
) => {
	// Template for incidents type
	const template = 'pilu_alerta5';

	const whichCollection =
		whichEnvURL(true) === 'live' ? 'notifications' : 'notifications_stage';

	// Set times to the Date data types
	startDate = setTime(new Date(startDate), 0, 0, 0);
	endDate = setTime(new Date(endDate), 23, 59, 59);

	try {
		let q = null;
		if (searchOption === 'División') {
			// Build the query for division search
			q = query(
				collection(db, whichCollection),
				where('created', '>=', startDate),
				where('created', '<=', endDate),
				where('template', '==', template),
				where('division', '==', division),
				orderBy('created')
			);
		} else if (searchOption === 'Asesor') {
			// Build the query for manager search
			q = query(
				collection(db, whichCollection),
				where('created', '>=', startDate),
				where('created', '<=', endDate),
				where('template', '==', template),
				where('order.created_by.id', '==', managerId),
				orderBy('created')
			);
		} else if (searchOption === 'Todo') {
			console.log({
				collection: whichCollection,
				startDate: startDate,
				endDate: startDate,
				template: template,
			});
			// Build the query no matter what division or manager
			q = query(
				collection(db, whichCollection),
				where('created', '>=', startDate),
				where('created', '<=', endDate),
				where('template', '==', template),
				orderBy('created')
			);
		}

		// Execute the query and retrieve the documents
		const querySnapshot = await getDocs(q);

		// Extract the data from the query snapshot
		const documents = querySnapshot.docs.map((doc) => ({
			id: doc.id,
			...doc.data(),
		}));

		return documents;
	} catch (error) {
		handleError(
			error,
			'Ocurrió un error intentando obtener las incidencias'
		);
	}
};

export const generateIncident = () => ({
	number_order: '',
	datetime: '',
	request_date: '',
	delivery_date: '',
	incident_number: '',
	division: '',
	manager: '',
	client: '',
	type: '',
	client_address: '',
	biases: [
		{
			id: 3639,
			description: '',
			incident_description: '',
		},
	],
});
